import {
    AudioTranscriptionHandler,
    AudioTranscriptionHandlerGetTermsPayload,
    AudioTranscriptionHandlerGetTermsResult, AudioTranscriptionHandlerImproveResult,
    AudioTranscriptionHandlerImproveTranscriptionPayload
} from "../../../../../../common/audio/transcription/api/component/audio-transcription-v2/audio-transcription-v2.component";
import {Injectable} from "@angular/core";
import {
    AiTranscriptionEntityGetPotentialTermsService
} from "../../../../../../ai/transcription/api/service/aiTranscriptionEntityGetPotentialTerms.service";
import {
    AiTranscriptionEntityImproveService
} from "../../../../../../ai/transcription/api/service/aiTranscriptionEntityImprove.service";

@Injectable()
export class ConsultationTranscriptionHandler extends AudioTranscriptionHandler<ConsultationTranscriptionHandlerSetupPayload> {
    consultationId: number;
    partnerId: number;

    constructor(private getPotentialTermsService: AiTranscriptionEntityGetPotentialTermsService,
                private transcriptionImproveService: AiTranscriptionEntityImproveService) {
        super();
    }

    protected coreSetup(payload: ConsultationTranscriptionHandlerSetupPayload) {
        this.consultationId = payload.consultationId;
        this.partnerId = payload.partnerId;
    }



    protected coreGetPotentialTerms(payload: AudioTranscriptionHandlerGetTermsPayload): Promise<AudioTranscriptionHandlerGetTermsResult> {
        return this.getPotentialTermsService.execute('MedicalConsultation', {
            medicalConsultationId: this.consultationId,
            partnerId: this.partnerId,
        });
    }

    protected coreImproveTranscription(payload: AudioTranscriptionHandlerImproveTranscriptionPayload): Promise<AudioTranscriptionHandlerImproveResult> {
        return this.transcriptionImproveService.execute({
            common: {
                transcription: payload.transcription,
                existingText: payload.existingText,
                entityName: 'MedicalConsultation'
            },
            custom: {
                medicalConsultationId: this.consultationId,
                partnerId: this.partnerId,
            }
        });
    }
}

export class ConsultationTranscriptionHandlerSetupPayload {
    consultationId?: number;
    partnerId?: number;
}